export const isThirdOrLastPosition = (array, index) => {
  const moreThanThreeAndSecondPosition = array.length >= 3 && index === 1
  const fewerThanThreeAndLastPosition =
    array.length <= 2 && index === array.length - 1

  return moreThanThreeAndSecondPosition || fewerThanThreeAndLastPosition
}
